import { EMPTY_ARRAY, IApplicationState, TBoardId } from '../../../../types/types';
import { getCardFieldsConf } from '../constants';
import { getListViewBoard } from './getListViewBoard';
import { ICardField } from '../store/listViewBoard/types';

export const getCardFields = (
    state: IApplicationState,
    boardId: TBoardId
): ICardField[] => {
    const cardFields = getCardFieldsConf(state, boardId);
    const shownFields = getListViewBoard(state, boardId).shownFields || EMPTY_ARRAY;
    return cardFields.map(cardField => {
        return {
            ...cardField,
            isShown: shownFields.includes(cardField.value)
        }
    });
}
